// --------------------------------------------------------------------------------------
// Uncomment below import if you want to activate Authorization Guard for you application
// --------------------------------------------------------------------------------------
import defaultGlobalGuard from "./helpers/defaultGlobalGuard";
import { requiresAuth } from "./constant.js";
import routes from "./routes";

const router = new window.VueRouter({
  mode: "history",
  base: "/aceas",
  routes: routes
});

// ----------------------------------------------------------------------------------------------
// Uncomment below router hook if you want to activate Authorization Guard for you application
// Reference: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
// ----------------------------------------------------------------------------------------------
if (requiresAuth) router.beforeEach(defaultGlobalGuard);

export default router;
